export const NAMESPACE = 'team-management/user-details';

export const TUNNELS_POLLING_INTERVAL = 5000; // 5 seconds
